import { Component,Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ProfileModel } from 'src/app/models/profile.model';
import { ProductModel } from 'src/app/models/product.model';
import { DataService } from 'src/app/services/data/data.service';
import { NavController, AlertController, ModalController } from '@ionic/angular';
import { MathService } from 'src/app/services/math/math.service';
import { TourneeModel } from 'src/app/models/tournee.model';
import { AmountEditorComponent } from '../amount-editor/amount-editor.component';
import { OrderModel } from 'src/app/models/order.model';

@Component({
  selector: 'basket',
  templateUrl: './basket.component.html',
  styleUrls: ['./basket.component.scss'],
})
export class BasketComponent implements OnInit {

  @Input()
  title:string;

  @Input()
  mode:string // edit, view, order, catalog, sale

  @Input()
  loading:boolean = false;

  @Input()
  disabled:boolean = false;

  @Input()
  tournee:TourneeModel;

  @Input()
  items:ProductModel[];

  @Input()
  sortBy:string

  @Input()
  owner:ProfileModel;

  @Output() quantityChanged = new EventEmitter<OrderModel>();




  constructor(private dataService:DataService, private navCtrl:NavController, 
    private alertCtrl:AlertController, public mathService:MathService,
    private modalCtrl:ModalController) {

  }

  ngOnInit(){

  }

  public edit(item:ProductModel){
    this.navCtrl.navigateForward('/producer/'+ this.owner.key+'/product/'+item.key+'/edit');
  }

  public add(){
    this.navCtrl.navigateForward('/producer/'+ this.owner.key+'/product/new');
  }

  publish(item:ProductModel){
    this.changeProductStatus(item,'published');
  }

  unpublish(item:ProductModel){
    this.changeProductStatus(item,'unpublished');
  }

  async changeProductStatus(product:ProductModel,status){
    product.status = status;
    this.dataService.updateProductStatus(product);
  } 

  async deleteProduct(item,i){
      const alert = await this.alertCtrl.create({
        header:'Supprimer',
        message:'Voulez-vous vraimer supprimer ce produit?',
        buttons:[{
          text: 'Non',
          handler: data => {
            //alert.dismiss();
          }
        },
      {
        text: 'Oui',
        handler: data => {
          //alert.dismiss();
          this.dataService.deleteProduct(item).then(_=>{
            this.items.splice(i,1);
          });
        }
      }]
      });
      await alert.present();
  }

  addToSale(item:ProductModel){
    item.status = 'included';
  }
  removeToSale(item:ProductModel){
    item.status = 'notIncluded';
  }

  sortAndTransformToArray(obj:any){
    if(!!obj){
      return Object.entries(obj)
        .map(entry => <ProductModel>{ key: entry[0],...entry[1] as {}})
    }
    else { return []}
  }

  async onProductClick(product:ProductModel){
    if(!this.disabled){
      const modal = await this.modalCtrl.create({
        component: AmountEditorComponent,
        cssClass: 'amount-editor',
        componentProps:{
          product:product,
          onValidate: (basket:any) => {
            product.basket.volumeDelivered = basket.volumeDelivered;
            product.basket.quantityDelivered = basket.quantityDelivered;
            product.basket.amountStatus = basket.amountStatus;
            product.basket.totalPriceVATIncluded = basket.totalPriceVATIncluded;
            product.basket.unitPriceVATIncluded = (basket.unitPriceVATIncluded != product.details.unitPriceVATIncluded?basket.unitPriceVATIncluded :null);
            modal.dismiss();
            this.quantityChanged.emit(product);
          }
        }
      });
      return await modal.present();      
    }
  }

}
